export const updatedSettingsForm2 =  [
  {
    id:'1',
    placeholder: "Mobile Number",
    type: "text",
    max: 10,
    name: "number",
    label: "Mobile Number",
    // countrycode: true,
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton"
  }
];

export const updatedSettingsForm3 =  [
  {
    id:'2',
    placeholder: "Email ID",
    type: "text",
    name: "email",
    label: "Email ID",
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton"
  },
];